export const inboxMerged = {
  inboxHeader: 'Prijemno sanduče',
  chatsHeader: 'Razgovori',
  contactsHeader: 'Kontakti',
  segmentsHeader: 'Grupe',
  ordersHeader: 'Narudžbe',
  exportStatus: 'Status izvoza',
  tasksExport: 'Izvoz zadatka',
  download: 'Preuzmi',
  ourAllNewOmniChannelInbox: 'Naše novo Omni-kanalno prijemno sanduče!',
  allYourMessagesContactsAndLeads: 'Sve vaše poruke, kontakti i potencijalni kupci sada su na jednom mjestu. Spremni su za sortiranje i grupiranje kako bi vaš posao rastao!',
  close: 'Zatvori',
  takeALook: 'Pogledajte',
  inProgress: 'u tijeku',
  appTooltip: {
    manageAllYourLeadsHere: 'Upravljajte svim svojim potencijalnim kupcima/kontaktima ovdje',
    segmentYourUserLeads: `Razvrstajte svoje potencijalne kupce/bot korisnike prema demografskim podacima i interesima. Ovi će se koristiti u stvaranju emitiranja`,
    manageAllBotsConversationsHere: 'Upravljajte svim razgovorima s botovima ovdje',
    manageAllYourOrdersHere: 'Upravljajte svim svojim narudžbama ovdje',
  },
  contacts: {
    seeHowToUse: 'Pogledaj kako koristiti',
    help: 'Pomoć',
    visitorName: 'Ime posjetitelja',
    email: 'Email',
    phoneNumber: 'Broj telefona',
    segment: 'Grupa',
    status: 'Status',
    tag: 'Oznaka',
    action: 'Akcija',
    discard: 'Odbaci',
    addTag: 'Dodaj oznaku',
    loadMore: 'Učitaj više',
    nA: 'N/A',
    assign: 'Dodijeli',
    deleteUser: 'Izbriši korisnika',
    areYouSureToDeleteLead: 'Jeste li sigurni da želite izbrisati ovog potencijalnog kupca?',
    twilioIntegrationNeeded: 'Integrazione Twilio necessaria',
    twilioIntegrationNeededDescription: 'Twilio non è attualmente collegato alla tua casella di posta. Procedi con l\'integrazione per chiamare i tuoi clienti.',
    call: 'Chiama',
    twilioMakeCall: 'Twilio integrato correttamente. Ora puoi effettuare chiamate agli utenti.',
    makeACall: 'Fare una chiamata',
    integrateNow: 'Fare una chiamata',
    subscribeUser: 'Pretplati se korisnik',
    unsubscribeUser: 'Otkaži pretplatu korisnika',
    copy: 'Kopirati',
    noDataFound: {
      youDoNotHaveAnyContactsYet: 'Još nemate kontakte!',
      allOfYourContactsAppearHere: 'Svi vaši kontakti pojavit će se ovdje'
    },
    placeholders: {
      searchSegmentByName: 'Pretraži po imenu grupe',
      searchOrAddTag: 'Pretraži ili dodaj oznaku',
    },
    addContacts: {
      name: 'Ime',
      email: 'Email',
      enterAValidEmail: 'Unesite valjanu email adresu',
      phoneNumber: 'Broj telefona',
      cancel: 'Odustani',
      addContact: 'Dodaj kontakt',
      placeholders: {
        enterEmailAddress: 'Unesite email adresu',
        enterUserrName: 'Unesite korisničko ime',
        searchCountry: 'Pretraži državu',
        enterPhoneNumber: 'Unesite broj telefona',
      }
    }
  },
  inboxFilter: {
    applied: 'primijenjeno',
    assignTags: 'Dodijeli oznake',
    discard: 'Odbaci',
    addTag: 'Dodaj oznaku',
    assignSegments: 'Dodijeli grupe',
    filterYourLeads: 'Filtriraj svoje potencijalne kupce',
    filters: 'filteri',
    filter: 'filter',
    resetAllFilters: 'Resetiraj sve filtere',
    importContacts: 'Uvezi kontakte',
    beforeYouStart: 'Prije nego počnete s uvozom, pobrinite se',
    point1: '1. Preuzmite primjer Excel datoteke.',
    point2: '2. Počnite unositi podatke od 2. retka nadalje.',
    point3: '3. U svakom retku bit će podaci za jedan kontakt.',
    point4: '4. Pobrinite se da su svi brojevi telefona jedinstveni.',
    point5: '5. Maksimalna veličina datoteke za uvoz je 20 MB.',
    selectFile: 'Odaberi datoteku',
    clickHere: 'Klikni ovdje',
    toDownloadSampleFile: 'za preuzimanje primjer datoteke',
    modal: {
      closeLeads: 'Zatvori potencijalne kupce',
      areYouSureToselectAllLeads: 'Jeste li sigurni da želite zatvoriti sve odabrane potencijalne kupce?',
      assignAgent: 'Dodijeli agenta',
      toAssignAgentToAllLeads: 'Jeste li sigurni da želite dodijeliti agenta svim odabranim potencijalnim kupcima?',
      assignTag: 'Dodijeli oznaku',
      wantToReplacePreviouslyAssignedTagWithNew: 'Jeste li sigurni da želite zamijeniti prethodno dodijeljene oznake novom odabranom oznakom za sve odabrane potencijalne kupce?',
      deleteLeads: 'Izbriši potencijalne kupce',
      wantToDeleteSelectedLeads: 'Jeste li sigurni da želite izbrisati sve odabrane potencijalne kupce?',
      exportData: 'Izvezi podatke',
      exportDataBasedOn: 'Izvezi podatke na temelju ',
      assignSegment: 'Dodijeli grupu',
      wantToAssignSegmentsToSelectedLeads: 'Jeste li sigurni da želite dodijeliti grupu svim odabranim potencijalnim kupcima?',
      yesGoAhead: 'Da, nastavi!',
      export: 'Izvezi'
    },
    appTooltip: {
      filterDataBasedOnPreferences: 'Filtrirajte podatke prema svojim postavkama poput oznaka, bota, statusa, itd.',
      markLeadAsClosed: 'Označi korisnika/potencijalnog kupca kao zatvorenog',
      assignAgentToLead: 'Dodijeli agenta korisniku',
      assignTagToUser: 'Dodijeli oznaku korisniku',
      exportData: 'Izvezi podatke',
      importContactsForWhatsappBot: 'Uvezi kontakte za WhatsApp bota',
      addWhatsappContact: 'Dodaj kontakte na WhatsApp-u',
      assignSegmentToUser: 'Dodijeli grupu korisniku',
      deleteUsers: 'Izbriši korisnike',
    },
    placeholders: {
      typeNameEmailPhoneNumberAndPressEnter: 'Upišite ime, email ili telefon i pritisnite Enter',
      searchAgentByName: 'Traži agenta po imenu',
      searchOrAddTag: 'Traži ili dodaj oznaku',
      searchSegmentByName: 'Traži grupu po imenu',
    },
    filterContainer: {
      filterOn: 'Filtriraj prema',
      filterBy: 'Filtriraj po',
      startFrom: 'Počni od',
      tillDate: 'Do datuma',
      offlineOrOnline: 'Van mreže/U mreži',
      liveChat: 'Uživo razgovor',
      userInteractedWithBot: 'Korisnik je interagirao s botom',
      discard: 'Odbaci',
      applyFilter: 'Primijeni filter',
      bots: 'Botovi',
      tags: 'Oznake',
      status: 'Status',
      assignedTo: 'Dodijeljeno',
      lastMessageBy: 'Posljednja poruka od strane',
      onlineOrOffline: 'U mreži/Van mreže',
      userInteracted: 'Korisnik je interagirao',
      segments: 'Grupe',
      lastSeenDate: 'Datum zadnjeg viđenja',
      onboardingDate: 'Datum registracije',
      createTags: 'Kreiraj oznake',
      createTagsToSortAndManageLeads: 'Kreirajte oznake kako biste lako sortirali i upravljali svojim potencijalnim kupcima',
      typeYourTagHere: 'Upišite oznaku ovdje',
      createSegment: 'Kreiraj grupu',
      manageSegmentForMarketingAutomation: 'Upravljajte grupama za marketinšku automatizaciju',
      typeYourSegmentHere: 'Poništavanje pretplate',
      unSubscribers: 'odjavljivači pretplate',
      unSubscriberUsers: 'Korisnici koji nisu pretplaćeni',
      placeholders: {
        searchFilter: 'Pretraži filter',
        searchByBotName: 'Traži po imenu bota',
        searchOrAddTag: 'Traži ili dodaj oznaku',
        searchByAgentName: 'Traži po imenu agenta',
        searchBySegments: 'Traži po grupama',
      },
      appTooltip: {
        dateRangeYouWishToEndSelectionAt: 'Raspon datuma koji želite završiti odabirom',
        dateRangeYouWishToStartSelectionFrom: 'Raspon datuma koji želite započeti odabirom',
        filterThoseThatAreOfflineOrOnline: 'Filtrirajte korisnike koji su van mreže/u mreži',
        filterThoseThatAreCurrentlyLiveChatting: 'Filtrirajte korisnike koji trenutno uživo razgovaraju',
        filterThoseThatInteractedWithBot: 'Filtrirajte korisnike koji su interagirali s botom',
        filterBySubscribers: 'Filtrirajte prema statusu pretplatnika',
      },
      indexMergeDatePicker: {
        selectStartDate: 'Odaberite početni datum',
        selectEndDate: 'Odaberite završni datum',
      }
    }
  },
  leads: {
    seeHowToUse: 'Vidi kako koristiti',
    help: 'Pomoć',
    visitorName: 'Ime posjetitelja',
    email: 'Email',
    phoneNumber: 'Broj telefona',
    assignedTo: 'Dodijeljeno',
    status: 'Status',
    tag: 'Oznaka',
    action: 'Akcija',
    discard: 'Odbaci',
    addTag: 'Dodaj oznaku',
    loadMore: 'Učitaj više',
    nA: 'NA',
    deleteUsers: 'Izbriši korisnika',
    areYouSureToDeleteLead: 'Jeste li sigurni da želite izbrisati ovog potencijalnog kupca?',
    twilioIntegrationNeeded: 'Integrazione Twilio necessaria',
    twilioIntegrationNeededDescription: 'Twilio non è attualmente collegato alla tua casella di posta. Procedi con l\'integrazione per chiamare i tuoi clienti.',
    call: 'Chiama',
    twilioMakeCall: 'Twilio integrato correttamente. Ora puoi effettuare chiamate agli utenti.',
    makeACall: 'Fare una chiamata',
    integrateNow: 'Fare una chiamata',
    subscribeUser: 'Pretplati se korisnik',
    unsubscribeUser: 'Otkaži pretplatu korisnika',
    copy: 'Kopirati',
    noDataFound: {
      youDoNotHaveAnyChatsYet: 'Još nemate nikakve razgovore',
      allOfYourChatsAppearHere: 'Svi vaši razgovori bit će prikazani ovdje',
    },
    placeholders: {
      searchAgentByName: 'Pretraži agenta po imenu',
      searchStatusByName: 'Pretraži status po imenu',
      searchOrAddTag: 'Pretraži ili dodaj oznaku',
    }
  },
  messages: {
    seeHowToUse: 'Vidi kako koristiti',
    help: 'Pomoć',
    editChatFlow: 'Uredi tijek razgovora',
    connect: 'Poveži',
    chat: {
      photo: 'Fotografija',
      video: 'Video',
      document: 'Dokument',
      location: 'Lokacija',
      assignedTo: 'Dodijeljeno',
      selectBot: 'Odaberi Bota',
      discard: 'Odbaci',
      addTag: 'Dodaj Oznaku',
      yourBrowserDoesNotSupportVideoTag: 'Vaš preglednik ne podržava video oznaku.',
      userHasSharedADocument: 'Korisnik je podijelio dokument.',
      clickHereToDownload: 'Klikni ovdje za preuzimanje',
      thisStoryIsNoLongerAvailable: 'Ova priča više nije dostupna',
      yourBrowserDoesNotSupportAudioElement: 'Vaš preglednik ne podržava audio element.',
      thisMessageIsNoLongerAvailable: 'Ova poruka više nije dostupna jer ju je pošiljatelj povukao',
      userHasSharedHisLocation: 'Korisnik je podijelio svoju lokaciju. Kliknite ovdje za pregled',
      sms: 'SMS',
      failed: 'Neuspjelo',
      a: 'A',
      i: 'I',
      r: 'R',
      m: 'M',
      conversationsSelected: 'razgovora odabrano',
      nA: 'NA',
      assignTagsCloseOrBulkReply: 'Dodijelite oznake, zatvorite ili odgovorite masovno odjednom',
      twilioIntegrationNeeded: 'Integrazione Twilio necessaria',
      twilioIntegrationNeededDescription: 'Twilio non è attualmente collegato alla tua casella di posta. Procedi con l\'integrazione per chiamare i tuoi clienti.',
      call: 'Chiama',
      twilioMakeCall: 'Twilio integrato correttamente. Ora puoi effettuare chiamate agli utenti.',
      makeACall: 'Fare una chiamata',
      integrateNow: 'Fare una chiamata',
      appTooltip: {
        assignAgent: 'Dodijeli agenta',
        selectBot: 'Odaberi Bota',
        callUser: 'Chiama utente',
        assignTagsToManageLeads: 'Dodijelite oznake za upravljanje potencijalnim kupcima i razgovorima',
      },
      placeholders: {
        searchAgentByName: 'Pretraži agenta po imenu',
        searchBotByName: 'Pretraži bota po imenu',
        searchOrAddTag: 'Pretraži ili dodaj oznaku',
        searchStatusByName: 'Pretraži status po imenu',
      }
    },
    profile: {
      userDetails: 'Detalji korisnika',
      orderDetails: 'Detalji narudžbe',
      orderedOn: 'Naručeno',
      showMore: 'Prikaži više',
      showLess: 'Prikaži manje',
      subTotal: 'Međuzbroj',
      nA: 'NA',
      addAWhatsappNumber: 'Dodaj broj WhatsApp-a',
      addTelegramUserName: 'Dodaj korisničko ime na Telegramu',
      addInstagramProfileId: 'Dodaj Instagram ID profila',
      addFacebookProfileId: 'Dodaj Facebook ID profila',
      add: 'Dodaj',
      deviceProperties: 'Svojstva uređaja',
      privateNotes: 'Privatne bilješke',
      urlsVisited: 'Posjećeni URL-ovi',
      source: 'Izvor - ',
      sourceNa: 'Izvor - NA',
      medium: 'Medij - ',
      mediumNa: 'Medij - NA',
      campaign: 'Kampanja - ',
      campaignNa: 'Kampanja - NA',
      attributeKey: 'Ključ atributa',
      attributeName: 'Naziv atributa',
      discard: 'Odbaci',
      addAttribute: 'Dodaj atribut',
      editAttribute: 'Uredi atribut',
      deleteAttribute: 'Izbriši atribut',
      headsUp: 'Upozorenje',
      areYouSureToDeleteAttribute: 'Jeste li sigurni da želite izbrisati ovaj atribut?',
      okay: 'U redu',
      dataAddedToLead: 'Atributi mapirani na vaše API-je neće se ažurirati. Ažurirajte API-je prema potrebi.',
      assignedOnly: 'Samo dodijeljeni',
      allUsers: 'Svi korisnici',
      save: 'Spremi',
      manageCustomAttributes: 'Upravljaj prilagođenim atributima',
      placeholders: {
        title: 'Naslov',
        egServices: 'Npr. Usluge',
        egRequestedServices: 'Npr. Tražene usluge',
        enterYourNotesHere: 'Unesite svoje bilješke ovdje ...'
      },
      bpDropDown: {
        selectBot: 'Odaberi Bota',
        selectFlow: 'Odaberi tok',
        selectQuestion: 'Odaberi Pitanje*'
      }
    },
    sendMessage: {
      send: 'Pošalji',
      sendToAllChannels: 'Pošalji na sve kanale',
      email: 'Email',
      whatsapp: 'WhatsApp',
      telegram: 'Telegram',
      facebook: 'Facebook',
      sendSms: 'Pošalji SMS',
      addNew: 'Dodaj novi',
      addNewQuickReply: 'Dodaj novi brzi odgovor',
      discard: 'Odbaci',
      fromComputer: 'SA RAČUNALA',
      add: 'Dodaj',
      dragAndDropHereOr: 'Povuci i ispusti ovdje ili',
      browseFiles: 'Pretraži datoteke',
      caption: 'Naslov',
      templates: 'Predlošci',
      addHeaderMedia: 'Dodaj medijski zaglavlje',
      selectFile: 'Odaberi datoteku',
      previousConversationClosed: 'Prethodni razgovor zatvoren!',
      sendTemplateMessage: 'Pošalji predložak poruke kako bi se ponovno pokrenula konverzacija.',
      selectTemplate: 'Odaberi predložak',
      conversationLocked: 'Konverzacija zaključana!',
      demoBotOnlyAllowConversations: 'Demo bot dopušta samo razgovore s brojem koji ste prethodno verificirali.',
      unSubscriberUser: 'Usuariu senza abbonatu',
      pleaseNoteEither: 'Per piacè nutate chì l\'Usuariu hà annullatu l\'abbonamentu o viceversa. Per piacè forzà l\'abbonamentu per inizià u chat.',
      subscribeAndStart: 'Subscribe & Start',
      placeholders: {
        searchQuickReplyByTitle: 'Pretraži brze odgovore po naslovu',
        addTitle: 'Dodaj naslov',
        addYourRepliesHere: 'Dodajte svoje odgovore ovdje... ',
        addCaption: 'Dodaj naslov',
        enterValueForThisVariable: 'Unesite vrijednost za ovu varijablu',
      },
      modal: {
        sendBulkMessages: 'Pošalji masovne poruke',
        send: 'Pošalji',
        description: 'Vaša će poruka biti dezinficirana i poslana na temelju vrste platforme kojoj korisnik pripada.' +
        '\n - Korisnici na web mjestu podržavaju samo tekstualne poruke \n - Korisnici WhatsApp-a (ne pretplaćeni) mogu primati samo predložak poruka'
      },
      noDataFound: {
        oops: 'Ups!',
        currentlyDoesNotSupportBulkMessages: 'Trenutačno ne podržavamo masovne poruke za WhatsApp botove. Koristite mogućnost emitiranja',
        quickReplies: 'Brzi odgovori',
        noQuickRepliesAddedYet: 'Još nisu dodani brzi odgovori!',
      }
    },
    userList: {
      selectAll: 'Odaberi sve',
      nA: 'NA',
      loadMore: 'Učitaj više',
    }
  },
  segments: {
    seeHowToUse: 'Pogledajte kako koristiti',
    help: 'Pomoć',
    manageSegment: 'Upravljajte grupom',
    manageYourSegmentsForMarketingAutomation: 'Upravljajte grupama za marketing automatizaciju',
    createNewSegment: 'Kreiraj novu grupu',
    segmentName: 'Ime grupe',
    totalContacts: 'Ukupno kontakata',
    action: 'Akcija',
    createSegmentButton: 'Kreiraj grupu',
    deleteSegments: 'Izbriši grupe',
    areYouSureToDeleteSegment: 'Jeste li sigurni da želite izbrisati ovu grupu?',
    placeholders: {
      searchHere: 'Pretraži ovdje',
    },
    noDataFound: {
      youDoNotHaveAnySegmentYet: 'Još niste stvorili nijednu grupu',
      allYourSegmentsAppearHere: 'Sve vaše grupe će se prikazati ovdje'
    },
    modal: {
      exportData: 'Izvezi podatke',
      exportDataBasedOnAppliedFilters: 'Izvezi podatke prema primijenjenim filtroma',
      export: 'Izvoz',
    },
    appTooltip: {
      deleteSegments: 'Izbriši grupe',
      editSegment: 'Uredi grupu',
      downloadSegment: 'Preuzmi grupu',
      deleteSegment: 'Izbriši grupu'
    },
    createSegment: {
      createSegment: 'Kreiraj grupu',
      manageYourSegmentsForMarketingAutomation: 'Upravljajte grupama za marketing automatizaciju',
      segmentName: 'Ime grupe',
      segmentNameIsRequired: 'Ime grupe je obavezno',
      selectContactsFilterForSegment: 'Odaberite filtre kontakta za grupu',
      filterYourContacts: 'Filtrirajte svoje kontakte',
      removeAllFilters: 'Uklonite sve filtre',
      addFilters: 'Dodaj filtre',
      discard: 'Odbaci',
      filterSelected: 'Odabrani filteri',
      placeholders: {
        enterSegmentName: 'Unesite ime grupe',
      }
    }
  },
  orders: {
    visitorName: 'Ime posjetitelja',
    email: 'Email',
    phoneNumber: 'Broj telefona',
    status: 'Status',
    itemCount: 'Broj stavki',
    total: 'Ukupno',
    tag: 'Oznaka',
    noDataFound: {
      youDoNotHaveAnyOrdersYet: 'Još uvijek nemate nijednu narudžbu',
      allOfYourOrdersAppearHere: 'Sve vaše narudžbe će se pojaviti ovdje'
    },
  }
};
